import YoutubePlayer from './modules/video/youtube-player';
import NorthCVimeoPlayer from './modules/video/vimeo-player';

document.addEventListener('DOMContentLoaded', () => {
  const vimeoPlayers = document.querySelectorAll('iframe[id^=vimeo]');

  if (!vimeoPlayers || !vimeoPlayers.length) {
    return;
  }

  vimeoPlayers.forEach((element) => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          const video = new NorthCVimeoPlayer(element);
          video.init();
        }
      });
    });

    // Try initiating
    if (element.hasAttribute('src')) {
      const video = new NorthCVimeoPlayer(element);
      video.init();
    }

    observer.observe(element, {
      attributes: true,
    });
  });
});

window.onYouTubeIframeAPIReady = () => {
  const youtubePlayers = document.querySelectorAll('iframe[id^=yt]');

  if (!youtubePlayers || !youtubePlayers.length) {
    return;
  }

  youtubePlayers.forEach((element) => {
    const video = new YoutubePlayer(element);
    video.init();
  });
};
